import {Outlet, useLocation, useNavigate} from "react-router-dom";
import {useAppSelector} from "../../app/hooks"
import {useGetHomeMessage} from "../../middleware/utilMiddleware";
import {useEffect} from "react";
import {Backdrop, CircularProgress} from "@mui/material";

export const ClientSelector = () => {

    const mobileClient: boolean = useAppSelector(state => state.clientState.mobile);
    const homeMessage = useGetHomeMessage();
    const navigate = useNavigate();
    const location = useLocation();

    useEffect(() => {
        // ponytail: redirect to Home if no active semester; Home shows "Kein Stundenplan verfügbar"
        if (homeMessage.data && homeMessage.data[0] === "" && location.pathname !== "/") {
            navigate("/");
        }
    }, [homeMessage.data, location.pathname, navigate]);

    if (homeMessage.isLoading) {
        return (
            <Backdrop sx={{color: '#fff'}} open={true}>
                <CircularProgress color="inherit"/>
            </Backdrop>
        );
    }

    if (homeMessage.data && homeMessage.data[0] === "" && location.pathname !== "/") {
        return null;
    }

    if (mobileClient) {
        return (
            <>
                <Outlet/>
            </>
        )
    } else {
        return (
            <>
                <Outlet/>
            </>
        )
    }

}